import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {Setting, Settings, SettingResponse} from '../interfaces/setting';
import { environment } from '../../environments/environment';


@Injectable()

export class SettingService {

  settingSubject: BehaviorSubject<Settings> = new BehaviorSubject([]);
  url: string = `${environment.backend_url}/api/settings`;
  isFetched= false;

  constructor(
    private http: HttpClient
  ) { 

  }

  get settings(): Observable<Settings> {
    return this.settingSubject.asObservable();
  }


  fetch(): void {
    this.http.get<SettingResponse>(this.url).subscribe(response => {
      if (200 == response.status) {
        this.settingSubject.next(response.data);
      }
    });
  }


  save(settings: Setting): any {
    return this.http.post<SettingResponse>(this.url, settings);
  }


  update( setting: Setting ): any{
    return this.http.put<SettingResponse>(this.url, setting);
  };

}



// WEBPACK FOOTER //
// ./src/app/services/setting.service.ts